var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGenerateMap(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 16,
    viewBox: "0 0 19 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.7024 -0.00118446L6.74944 -0.00244141L6.7952 -0.0012331C6.81763 6.0509e-05 6.84011 0.00239283 6.86258 0.00579667L6.87865 0.00960279C6.96406 0.0233245 7.04894 0.0538271 7.12984 0.101754L7.18171 0.135294L12.252 3.70056L17.3191 0.13864C17.7868 -0.190152 18.4205 0.105375 18.4935 0.647715L18.5004 0.752205V11.3847C18.5004 11.5941 18.413 11.7921 18.2623 11.9329L18.1817 11.9983L12.6817 15.8647C12.4148 16.0523 12.0939 16.0366 11.8539 15.8878L6.74905 12.2966L1.67937 15.8613C1.21165 16.1901 0.577913 15.8946 0.504974 15.3523L0.498047 15.2478V4.61523C0.498047 4.40591 0.585399 4.20783 0.736167 4.06706L0.816725 4.00167L6.31672 0.135294C6.38073 0.0903015 6.44784 0.057 6.5162 0.0344217L6.63867 0.00641608L6.7024 -0.00118446ZM17.0004 2.19621L13.0004 5.00812V13.8071L17.0004 10.9952V2.19621ZM5.99805 2.19287L1.99805 5.00478V13.8038L5.99805 10.9918V2.19287ZM7.50039 2.19287V10.9918L11.5004 13.8038V5.00478L7.50039 2.19287Z",
    fill: "#190134"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenerateMap);
export default __webpack_public_path__ + "static/media/GenerateMap.f7763a39ae54589d35bbe3126fb4b441.svg";
export { ForwardRef as ReactComponent };